"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  FormField: true
};
exports.FormField = FormField;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formFieldModule = _interopRequireDefault(require("./form-field.module.scss"));
var _FormFieldLabel = require("./form-field-label/FormFieldLabel");
var _FormFieldMessage = require("./form-field-message/FormFieldMessage");
Object.keys(_FormFieldMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormFieldMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FormFieldMessage[key];
    }
  });
});
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
function FormField(_ref) {
  var children = _ref.children,
    id = _ref.id,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? {} : _ref$label,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    instruction = _ref.instruction,
    submitted = _ref.submitted,
    errorMessage = _ref.errorMessage,
    required = _ref.required,
    tooltip = _ref.tooltip;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var modifiedLabel = (0, _react.useMemo)(function () {
    return required ? label : (0, _objectSpread2.default)((0, _objectSpread2.default)({}, label), {}, {
      extra: t('formField.optional')
    });
  }, [t, label, required]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "field-container-".concat(id),
    className: (0, _classnames.default)(className, _formFieldModule.default["field-".concat(size)])
  }, /*#__PURE__*/_react.default.createElement(_FormFieldLabel.FormFieldLabel, Object.assign({
    id: id
  }, modifiedLabel, {
    tooltip: tooltip
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _formFieldModule.default['field__input-container']
  }, children), /*#__PURE__*/_react.default.createElement(_FormFieldMessage.FormFieldMessage, {
    submitted: submitted,
    instruction: instruction,
    errorMessage: errorMessage
  }));
}